import scrollTo from './animation/scrollTo';
import getElementTop from './elements/getElementTop';
import addTargetEventListener from './events/addTargetEventListener';

const SCROLL_BUTTON_SELECTOR = '.leadform a.edge-button[href^="#"]';
const BACK_BUTTON_SELECTOR = [
  '.lead-constructor__panel:first-child .js-lead-constructor__back',
  '.form--form-wizard .leadform-panel:first-child [data-trigger=back]',
].join();
const LEADFORM_REPLACE_TARGET_HIDDEN_CLASS = 'leadform-replace-target--hidden';

export function clickedScrollButton(event) {
  event.preventDefault();

  const target = document.getElementById(this.getAttribute('href').replace(/^#/, ''));
  const top = getElementTop(target);

  scrollTo(top);
}

// If 'replace: selector' is set in the lead_form params, the first back
// button should show the old element and hide the leadform
export function showLeadformReplaceTarget(event) {
  event.preventDefault();

  const leadform = document.querySelector('.leadform, .form-wizard');
  const oldElement = document.querySelector(`.${LEADFORM_REPLACE_TARGET_HIDDEN_CLASS}`);

  if (leadform && oldElement) {
    oldElement.classList.remove(LEADFORM_REPLACE_TARGET_HIDDEN_CLASS);
    leadform.classList.add('leadform--hidden');
  }
}

addTargetEventListener('click', SCROLL_BUTTON_SELECTOR, clickedScrollButton);
addTargetEventListener('click', BACK_BUTTON_SELECTOR, showLeadformReplaceTarget);
